<p-toast
  key="announcements"
  position="top-right"
  styleClass="announcement-toast"
  (onClose)="dismissAnnouncement($event)">
</p-toast>
